import { render, staticRenderFns } from "./requisitar_exame_pet.vue?vue&type=template&id=10112322"
import script from "./requisitar_exame_pet.vue?vue&type=script&lang=js"
export * from "./requisitar_exame_pet.vue?vue&type=script&lang=js"
import style0 from "./requisitar_exame_pet.vue?vue&type=style&index=0&id=10112322&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports